
export const BASE_CDN_URL = 'https://cdn.nowaycdn.com'
export const CDN_SUBROUTES = {
  IMAGES: {
    BASE: '/images',
    CHAMPS: {}
  },

}

export type ImageSizes = '16x' | '32x' | '64x' | '128x' | '256x' | '512x' | '1024x' | 'full'

export const buildRankUri = (rank: string, size: ImageSizes = 'full') => {
  const normalized = (rank || "UNRANKED").toUpperCase();
  return `ranks/full/${normalized}.png`;
}
export const buildChampUri = (champ: string | Number, size: ImageSizes = '32x') => {
  return `champions/square/${size}/${champ.toString()}.png`
}

export const buildPerkUri = (perk: string | Number, size: ImageSizes = '32x') => {
  return `masteries/${size}/${perk.toString()}.png`
}

export const buildItemUri = (item: string | Number, size: ImageSizes = '32x') => {
  return `items/${size}/${item.toString()}.png`
}

export const buildSpellUri = (spell: string | Number, size: ImageSizes = '32x') => {
  return `spells/${size}/${spell.toString()}.png`
}


export const buildCDNChampUri = (champ: string | Number, size: ImageSizes = '32x') => {
  return `${BASE_CDN_URL}/images/champions/square/${size}/${champ.toString()}.png`
}
export const buildCDNItemUri = (item: string | Number, size: ImageSizes = '32x') => {
  return `${BASE_CDN_URL}/images/items/square/${size}/${item.toString()}.png`
}
export const buildCDNPerkUri = (perk: string | Number, size: ImageSizes = '32x') => {
  return `${BASE_CDN_URL}/images/masteries/32x/${perk.toString()}.png`
}
export const buildCDNSpellUri = (spell: string | Number, size: ImageSizes = '32x') => {
  return `${BASE_CDN_URL}/images/spells/${size}/${spell.toString()}.png`
}

const CHAMPION_SPLASH_MAP: Record<string, string> = {
  "MonkeyKing": "MonkeyKing",
  "Wukong": "MonkeyKing",
  "Cho'Gath": "Chogath",
  "Chogath": "Chogath",
  "Kai'Sa": "Kaisa",
  "Kaisa": "Kaisa",
  "Kha'Zix": "Khazix",
  "Khazix": "Khazix",
  "LeBlanc": "Leblanc",
  "Leblanc": "Leblanc",
  "Vel'Koz": "Velkoz",
  "Velkoz": "Velkoz",
  "Bel'Veth": "Belveth",
  "Belveth": "Belveth",
  "Kog'Maw": "KogMaw",
  "Kogmaw": "KogMaw",
  "Rek'Sai": "RekSai",
  "Reksai": "RekSai",
};

export type ChampionArtSize = '384x' | '768x' | '1280x' | 'full';

export const buildSplashUri = (champ: string, size: ChampionArtSize = '768x', skin = 0) => {
  const clean = CHAMPION_SPLASH_MAP[champ] || champ.replace(/[^a-zA-Z0-9]/g, '');
  return `${BASE_CDN_URL}/images/champions/splash/${size}/${clean}_${skin}.jpg`;
}

